import { styled, Box } from '@mui/material';

export const DrawerWrapperStyled = styled('div')({
  '.btn.btn-link': { textDecoration: 'underline' },
  '.btn.btn-link:hover': { background: '#FFFFFF' },
});

export const PlanDetailsHeaderSyled = styled(Box)({
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '4px',
  '@media (max-width: 743px)': {
    display: 'block',
  },
});

export const PlanTitleAccent = styled('div')({
  content: '',
  width: '76px',
  height: '8px',
  backgroundColor: 'var(--branding-secondary-600)',
  borderRadius: '4px',
  display: 'block',
  position: 'relative',
  marginTop: '6px',
});

export const CarrierLogoBoxStyled = styled(Box)({
  display: 'block',
  marginLeft: 'auto',
  marginRight: 'auto',
  padding: '16px 0px 16px 0px',
  '@media (min-width: 744px)': {
    display: 'flex',
    alignItems: 'right',
    marginLeft: 'auto',
    marginRight: 0,
    padding: '16px 0px 16px 0px',
  },
});

export const CarrierImageStyled = styled('img')({
  maxHeight: '48px',
  maxWidth: '141px',
  display: 'block',
  margin: 'auto',
});
